// TODO: don't understand the need for this...seems to do nothing?

import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Query = require("arcgis/services/featureserver/query");
import Backbone = require("backbone");
import Templates = require("../models/defaults");
import Base = require("./base-command");
import Controller = require("../controls/controller");
import geo = require("../utils/geo");
const log = Utils.log;

class Handler extends Base<{
    in: any;
    out: {
        filter: any;
        layers: Rhythm.GIS.FeatureQueryResultLayer[];
        metadata: any;
        symbology: string;
        typeName: string;
        url: string;
    }
}> {

    static about = `
DEPRECATE.

This is essentially just forwarding events (e.g. listen for "foo", trigger "bar1,bar2") so 
could be replaced with base-command once dependent events are 'findOption' aware
`;

static options = {
    "panmap": {
        "about": "forwarded to listeners to indicate if the map is allowed to pan",
        "default": "true",
    },
    "symbology": {
        "about": "forwarded to listeners to indicate how the results should be rendered",
    },        
    "zoommap": {
        "about": "forwarded to listeners to indicate if the map is allowed to zoom",
        "default": "false",
    },
}

    execute(args = this.args) {

        log("geoquery-result-handler:", args.out);

        if (!args.out.layers || !args.out.layers[0] || !args.out.layers[0].features.length) {
            this.trigger("growl", {
                message: "No Results Found."
            });
            return;
        }

        let options = Utils.defaults(this.asOptions(Handler.options), {
            event: this.configuration.id,
        });

        // this was a bad idea to have 'helper' configurations, should just let the handler dig into the args.in until it finds what it wants
        this.trigger(_.defaults(args.out, {
            panmap: options.panmap === "true",
            zoommap: options.zoommap === "true",
            symbology: this.findOption("symbology")
        }));

    }


}

export = Handler;   